import * as Cesium from 'cesium';

/**
 * Floating map buttons (bottom right):
 * - Reset view (circle arrow): back to the default Stuttgart view
 */
export function setupMapActions(viewer, config) {
  const resetBtn = document.getElementById('resetViewBtn');

  // Blickwinkel der Standardansicht (senkrecht von oben, Draufsicht auf STR).
  const RESET_PITCH_DEG = -90;

  resetBtn.addEventListener('click', () => {
    const { center, initialAltitude } = config.region;

    // Die Kamera nicht direkt ÜBER STR setzen (dann liegt STR am unteren
    // Bildrand und der südliche Teil des Radius ist nicht sichtbar), sondern
    // südlich davon: Bei Neigung `pitch` trifft die Sichtlinie den Boden in
    // horizontaler Distanz d = H / tan(|pitch|) nördlich der Kamera. Legt man
    // die Kamera um genau diese Distanz südlich von STR, landet STR mittig im
    // Bild und der gesamte Radius ist sichtbar.
    const pitchRad = Cesium.Math.toRadians(RESET_PITCH_DEG);
    const groundDistance = initialAltitude / Math.tan(Math.abs(pitchRad));
    const metersPerDegLat = 111320;
    const latOffset = groundDistance / metersPerDegLat;

    viewer.camera.flyTo({
      destination: Cesium.Cartesian3.fromDegrees(
        center.lon,
        center.lat - latOffset,
        initialAltitude
      ),
      orientation: {
        heading: Cesium.Math.toRadians(0),
        pitch: pitchRad,
        roll: 0
      },
      duration: 1.5
    });
  });
}
